<template>
  <div class="w-full min-w-full">
    <div
      class="flex-1 focus:outline-none"
      tabindex="0"
    >
      <div class="relative z-10 flex-shrink-0 flex h-16 bg-white border-b border-gray-200 lg:border-none">
        <button
          class="px-4 border-r border-cool-gray-200 text-cool-gray-400 focus:outline-none focus:bg-cool-gray-100 focus:text-cool-gray-600 lg:hidden"
          aria-label="Open sidebar"
        >
          <!-- Heroicon name: menu-alt-1 -->
          <svg
            class="h-6 w-6 transition ease-in-out duration-150"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </button>
        <!-- Search bar -->
        <div class="flex-1 px-4 flex justify-between sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
          <div class="flex-1 flex">
            <form
              class="w-full flex md:ml-0"
              action="#"
              method="GET"
            >
              <label
                for="search_field"
                class="sr-only"
              >Search</label>
              <div class="relative w-full text-cool-gray-400 focus-within:text-cool-gray-600">
                <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                  <svg
                    class="h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    />
                  </svg>
                </div>
                <input
                  id="search_field"
                  class="block w-full h-full pl-8 pr-3 py-2 rounded-md text-cool-gray-900 placeholder-cool-gray-500 focus:outline-none focus:placeholder-cool-gray-400 sm:text-sm"
                  placeholder="Search"
                  type="search"
                >
              </div>
            </form>
          </div>
          <div class="ml-4 flex items-center md:ml-6">
            <button
              class="p-1 text-cool-gray-400 rounded-full hover:bg-cool-gray-100 hover:text-cool-gray-500 focus:outline-none focus:shadow-outline focus:text-cool-gray-500"
              aria-label="Notifications"
            >
              <svg
                class="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
            </button>

            <!-- Profile dropdown -->
            <div class="ml-3 relative">
              <div @click="profileDropdown.show = !profileDropdown.show">
                <button
                  id="user-menu"
                  class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:bg-cool-gray-100 lg:p-2 lg:rounded-md lg:hover:bg-cool-gray-100"
                  aria-label="User menu"
                  aria-haspopup="true"
                >
                  <div
                    class="h-8 w-8 rounded-full bg-gray-800 text-white flex items-center justify-center text-center text-sm font-light shadow-lg"
                  >
                    <div class="leading-none select-none">
                      {{ forename.charAt(0) }}{{ surname.charAt(0) }}
                    </div>
                  </div>
                  <p class="hidden ml-3 text-cool-gray-700 text-sm leading-5 font-medium lg:block">
                    {{ forename }} {{ surname }}
                  </p>
                  <!-- Heroicon name: chevron-down -->
                  <svg
                    class="hidden flex-shrink-0 ml-1 h-5 w-5 text-cool-gray-400 lg:block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>

              <div
                v-if="profileDropdown.show"
                class="origin-top-right z-40 absolute right-0 mt-2 w-48 rounded-md shadow-lg"
              >
                <Dropdown
                  :list="profileDropdown.items"
                  @click="profileAction"
                />
              </div>

              <div
                v-if="profileDropdown.show"
                class="fixed top-0 left-0 z-30 w-screen h-screen min-w-full min-h-screen"
                @click="profileDropdown.show = false"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Dropdown from '@/app/shared/components/dropdown/dropdown.vue';

export default {

  name: 'Header',

  components: {
    Dropdown,
  },

  data() {
    return {
      profileDropdown: {
        show: false,
        items: ['Your Account', 'Logout'],
      },
    };
  },

  computed: {
    ...mapState({
      username: state => state.user.username,
      emailAddress: state => state.user.emailAddress,
      forename: state => state.user.forename,
      surname: state => state.user.surname,
      tenant: state => state.user.tenant,
    }),

    view() {
      return this.$route.name;
    },
  },

  mounted() {

  },

  methods: {
    profileAction(item) {
      if (item === 'Logout') {
        this.logout();
      }

      this.profileDropdown.show = false;
    },

    logout() {
      this.$store.dispatch('emptyAccessToken').then(() => {
        this.$store.dispatch('emptyUserStore');
        this.$router.push('/Login');
      });
    },
  },

};
</script>
